import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Toaster } from "react-hot-toast";
import App from "./App";
import "./index.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 5000,
            style: {
              fontSize: '16px',
              padding: '16px 20px',
            },
            error: {
              duration: 8000,
              style: {
                fontSize: '18px',
                padding: '20px 24px',
                fontWeight: 'bold',
                backgroundColor: '#d32f2f',
                color: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(211, 47, 47, 0.4)',
              },
              iconTheme: {
                primary: '#fff',
                secondary: '#d32f2f',
              },
            },
          }}
        />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
